





























import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  watch,
  ref,
  nextTick,
} from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';

import DataTableActionIcons from '@/components/molecules/DataTableActionIcons.vue';
import DataTableToolbar from '@/components/organisms/DataTableToolbar.vue';
import EditingCard, {
  Props as EditingCardProps,
} from '@/components/organisms/EditingCard.vue';

import { i18n, useI18n } from '@/plugins/i18n/i18n';
import { editingCardModule } from '@/store/modules/EditingCardStore';

type ItemType = { [x: string]: string };

export interface Props {
  items: ItemType[];
  headers: DataTableHeader[];
  defaultItem: ItemType;
}

export default defineComponent({
  components: {
    DataTableToolbar,
    DataTableActionIcons,
    EditingCard,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    defaultItem: {
      type: Object,
      required: true,
    },
    sortBy: {
      type: String,
      required: false,
      default: '',
    },
    sortDesc: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  setup({ items, defaultItem }: Props, { emit }) {
    editingCardModule.initialize(defaultItem);
    const itemsPerPageText = useI18n('dataTable.footer.itemsPerPageText');

    const close = () => editingCardModule.initialize(defaultItem);

    const save = () => {
      const event = editingCardModule.isItemCreated ? 'create' : 'update';
      emit(event, editingCardModule.editedItem);
      close();
    };

    const deleteItem = (item: ItemType) => emit('delete', item);

    const openEditDialog = (item: ItemType, isItemCreated: boolean) =>
      editingCardModule.openDialog({ item, isItemCreated });

    const formTitle = computed(() => {
      const title = editingCardModule.isItemCreated ? 'newItem' : 'editItem';
      return i18n.tc(`commonSetting.cardTitle.${title}`);
    });

    const dialog = computed({
      get: () => editingCardModule.dialog,
      set: (dialog: boolean) =>
        dialog
          ? editingCardModule.openDialog({
              item: defaultItem,
              isItemCreated: true,
            })
          : editingCardModule.initialize(defaultItem),
    });

    return {
      itemsPerPageText,
      dialog,
      formTitle,
      openEditDialog,
      deleteItem,
      close,
      save,
    };
  },
});
